import { Typography } from '@repo/ui';
import styles from './FlaggedMetricsCount.module.css';

type FlaggedMetricsCountProps = {
  flagged: number;
  total: number;
  sensitive?: boolean;
};

export default function FlaggedMetricsCount({
  flagged,
  total,
  sensitive,
}: FlaggedMetricsCountProps) {
  if (sensitive)
    return (
      <Typography
        color='grey'
        variant='chart-label'
        className={styles.sensitiveLabel}
      >
        View details for flagged metrics
      </Typography>
    );

  return (
    <div className={styles.container}>
      <Typography color='grey' variant='chart-label' className={styles.label}>
        Flagged metrics
      </Typography>
      <Typography color='grey' variant='body-s'>
        {flagged} of {total}
      </Typography>
    </div>
  );
}
